<template>
  <div class="device-list-container">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h2>设备管理</h2>
      <p>管理所有物联网设备及相关信息</p>
    </div> -->

    <el-card class="main-card">
      <div slot="header" class="card-header">
        <div style="display : flex; align-items: center;gap: 6px;font-size: 14px;">
          设备名称：<el-input placeholder="请输入设备名称" style=" width: 200px;" v-model="searchKeyword"
                             prefix-icon="el-icon-search" class="search-input" @input="handleSearch"/>
          设备编码：<el-input placeholder="请输入设备编码" v-model="searchKeywordCode" prefix-icon="el-icon-search" style=" width: 200px;"
                             class="search-input" @input="handleSearch" />
          <div>
            <label>设备类型：</label>
            <el-select v-model="categoryId" placeholder="筛选设备类型" clearable @change="handleCategoryFilter">
               <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id">
                 {{item.name}}
               </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex; align-items: center; gap: 6px;">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddTemplateDevice" class="add-btn">
            添加模板设备
          </el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddDevice" class="add-btn">
            添加设备
          </el-button>
        </div>
      </div>

      <!-- 设备表格 -->
      <el-table :data="devices" border class="device-table" stripe highlight-current-row
        :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="设备ID" width="200" fixed />
        <el-table-column prop="code" label="设备编码" width="200" />
        <el-table-column prop="name" label="设备名称" show-overflow-tooltip width="200" />
        <el-table-column prop="categooryId" label="分类名称" show-overflow-tooltip width="180" :formatter="categoryNameFormat" />
        <el-table-column prop="officeName" label="所属企业" show-overflow-tooltip width="200" />
        <el-table-column prop="address" label="设备地址" show-overflow-tooltip width="220" />
        <el-table-column prop="validStart" label="开始时间" :formatter="validFormat" show-overflow-tooltip />
        <el-table-column prop="validEnd" label="到期时间" :formatter="validFormat" show-overflow-tooltip />
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleViewDetails(scope.row)" class="operation-btn view-btn">
              查看传感器
            </el-button>
            <el-button size="mini" type="text" @click="handleEditDevice(scope.row)" class="operation-btn edit-btn">
              编辑
            </el-button>

            <el-dropdown @command="(command) => handleCommand(command, scope.row)">
              <el-button size="mini" type="text" style="margin-left: 10px; color: #4b5563;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="office">企业关联</el-dropdown-item>
                <el-dropdown-item command="contact">设备管理员</el-dropdown-item>
                <!-- <el-dropdown-item command="location">地图标点</el-dropdown-item> -->
                <el-dropdown-item command="delete" class="delete-btn">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" class="pagination"></el-pagination>
      </div>
    </el-card>




    <!-- 新增模板设备信息弹窗 -->
    <el-dialog title="新增模板设备信息" :visible.sync="dialogVisibleTemplate" width="500px" :close-on-click-modal="false"
      :destroy-on-close="true" custom-class="custom-dialog">
      <el-form ref="deviceFormTemplate" :model="deviceFormTemplate" :rules="rulesThree" label-width="120px"
        class="device-form">



        <!-- 设备编码 -->
        <el-form-item label="设备编码" prop="equipmentCode">
          <el-input v-model="deviceFormTemplate.equipmentCode" placeholder="请输入设备编码" show-word-limit
            class="form-input"></el-input>
        </el-form-item>


        <!-- 模板编码 -->
        <el-form-item label="模板编码" prop="templateCode">
          <!-- <el-input v-model="deviceFormTemplate.templateCode" placeholder="请输入模板编码" show-word-limit
            class="form-input"></el-input> -->
          <el-select v-model="deviceFormTemplate.templateCode" placeholder="请选择模板" clearable class="form-select">
            <el-option v-for="item in devicesTemplate" :key="item.id" :label="item.templateName"
              :value="item.templateCode"></el-option>
          </el-select>
        </el-form-item>


        <!-- 摄像头编码 -->
        <el-form-item label="摄像头编码">
          <el-input v-model="deviceFormTemplate.cameraCode" placeholder="摄像头编码" class="form-input"></el-input>
        </el-form-item>


      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTemplate = false" class="dialog-btn cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleSaveTemplate" class="dialog-btn confirm-btn">保存</el-button>
      </div>
    </el-dialog>





    <!-- 新增设备信息弹窗 -->
    <el-dialog title="新增设备信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
      :destroy-on-close="true" custom-class="custom-dialog">
      <el-form ref="deviceForm" :model="deviceForm" :rules="rules" label-width="120px" class="device-form">
        <!-- 设备名称 -->
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="deviceForm.name" placeholder="请输入设备名称" maxlength="50" show-word-limit
            class="form-input"></el-input>
        </el-form-item>


        <!-- 设备编码 -->
        <el-form-item label="设备编码" prop="code">
          <el-input v-model="deviceForm.code" placeholder="请输入设备编码" maxlength="30" show-word-limit
            class="form-input"></el-input>
        </el-form-item>

        <!-- 设备类型 -->
        <el-form-item label="设备类型" prop="type">
          <el-select v-model="deviceForm.type" placeholder="请选择设备类型" clearable class="form-select">
            <el-option v-for="item in deviceTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备有效期">
          <el-date-picker
              v-model="validDateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="到期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="dialog-btn cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleSave" class="dialog-btn confirm-btn">保存</el-button>
      </div>
    </el-dialog>






    <!-- 修改设备信息弹窗 -->
    <el-dialog title="修改设备信息" :visible.sync="dialogVisibleEdit" width="60%" :close-on-click-modal="false"
      :destroy-on-close="true" custom-class="custom-dialog">
      <el-form ref="deviceFormEdit" :model="deviceFormEdit" :rules="rulesTwo" label-width="120px" class="device-form">
        <!-- 设备名称 -->
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="deviceFormEdit.name" placeholder="请输入设备名称" maxlength="50" show-word-limit
            class="form-input"></el-input>
        </el-form-item>

        <!-- 设备编码 -->
        <el-form-item label="设备编码" prop="code">
          <el-input v-model="deviceFormEdit.code" placeholder="请输入设备编码" maxlength="30" show-word-limit
            class="form-input"></el-input>
        </el-form-item>

        <!-- 设备类型 -->
        <el-form-item label="设备类型" prop="type">
          <el-select v-model="deviceFormEdit.type" placeholder="请选择设备类型" clearable class="form-select">
            <el-option v-for="item in deviceTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备有效期">
          <el-date-picker
              v-model="validDateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="到期时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input placeholder="请输入详细地址" v-model="deviceFormEdit.address">
            <el-cascader slot="prepend"
                         placeholder="请选择区域"
                         v-model="deviceFormEdit.cityPath"
                         :options="cityTreeData"
                         :props="{ expandTrigger: 'hover' , ...cityTreeProps}"
                         filterable
                         clearable
                         @change="changeCity"
                         style="width: 200px"
            />
          </el-input>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEdit = false" class="dialog-btn cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleEditSave" class="dialog-btn confirm-btn">保存</el-button>
      </div>
    </el-dialog>

    <ContactDrawer ref="contactRef" />
    <!-- <AMapSearchDialog ref="amapSearchRef" @refresh="refresh"/> -->

    <el-dialog :visible.sync="officeDialogVisible" title="企业关联" >
      <div style="display: flex;flex-direction: column;gap: 6px; flex: 1">
        <div style="display: flex; align-items: center; gap: 6px">
          <div>当前设备编码： <span>{{currentDevice.code}}</span></div>
          <div>当前设备名称： <span>{{currentDevice.name}}</span></div>
        </div>
        <div >
          <el-select v-model="currentDevice.officeId" placeholder="请选择企业" clearable class="form-select" @change="handleOffice">
            <el-option v-for="item in officeList" :key="item.id" :label="item.name"
                       :value="item.id" />
          </el-select>
        </div>

        <div style="display: flex;  justify-content: right; ">
          <el-button @click="officeDialogVisible = false" class="dialog-btn cancel-btn">取消</el-button>
          <el-button @click="updateOffice" class="dialog-btn confirm-btn">提交</el-button>
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import { deviceInfo, categoryInfo, addDevice, delDevice, addequipmnet } from '@/api/index'
import { templateList } from '@/api/template'
import {formatDate} from "@/utils/data";
import ContactDrawer from "@/components/ContactDrawer.vue";
import AMapSearchDialog from "@/components/AMapSearchDialog.vue";
import {officeList} from "@/api/office";
import {Message} from "element-ui";
import cityCodeData from '@/assets/city_code.json';

export default {
  name: 'DeviceList',
  components: { AMapSearchDialog, ContactDrawer},
  data() {
    return {
      searchKeyword: '',
      deviceStatus: '',
      deviceType: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogVisibleEdit: false,
      dialogVisibleTemplate: false,
      searchKeywordCode: "",
      validDateRange : [],
      // 企业
      officeList : [],
      currentDevice : {},
      officeDialogVisible: false,
      // 设备表单数据
      deviceForm: {
        name: '',
        code: '',
        type: ''
      },
      deviceFormEdit: {
        name: '',
        code: '',
        type: '',
        id: ''
      },
      deviceFormTemplate: {
        equipmentCode: "",
        templateCode: "",
        cameraCode: ""
      },
      devices: [],
      devicesTemplate: [],
      // 设备类型选项
      deviceTypes: [],
      cityTreeData : [],
      cityTreeProps: {
        children: 'children',
        label: 'value',
        value: 'code',
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入设备编码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ]
      },
      rulesTwo: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入设备编码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ]
      },
      rulesThree: {
        equipmentCode: [
          { required: true, message: '请输入设备编码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
        templateCode: [
          { required: true, message: '请输入模板编码', trigger: 'blur' },
          // { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
      },
      categoryId: null,
      categories : [],
    }
  },
  computed: {
    // 过滤设备列表 - 优化搜索逻辑
    filteredDevices() {
      // 如果没有搜索关键词，直接返回所有设备
      if (!this.searchKeyword) {
        return [...this.devices];
      }

      const keyword = this.searchKeyword.toLowerCase();
      return this.devices.filter(device => {
        // 确保设备名称和编码存在，避免undefined错误
        const nameMatch = device.name
          ? device.name.toLowerCase().includes(keyword)
          : false;
        const codeMatch = device.code
          ? device.code.toLowerCase().includes(keyword)
          : false;
        return nameMatch || codeMatch;
      })
    },
    // 分页处理
    pagedDevices() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredDevices.slice(startIndex, endIndex);
    }
  },
  mounted() {
    this.loadCityData();
    this.loadCategory();
    this.deviceList();
    this.categoryList(); // 提前加载设备类型
    this.fetchOffices(); // 加载企业列表
  },
  methods: {
    refresh () {
      this.currentPage = 1;
      this.deviceList();
    },

    async loadCityData() {
      try {
        this.cityTreeData = cityCodeData
      } catch (error) {
        console.error('加载城市数据失败:', error);
        Message.error('加载城市数据失败');
      }
    },
    changeCity(value){
      if ( value.length >= 1) {
        this.deviceFormEdit.provinceCode = value[0]
      }
      if ( value.length >= 2){
        this.deviceFormEdit.cityCode = value[1]
      }
      if ( value.length >= 3){
        this.deviceFormEdit.districtCode = value[2]
      }
    },

    async loadCategory(){
      try {
        const param = {
          current : 1,
          pageSize : 50
        }
        const res = await categoryInfo(param)
        this.categories = res.result.records || []
      } catch (error) {
        console.error(error)
      }
    },

    handleCategoryFilter(val){
      this.refresh();
      this.deviceList()

    },

    handleCommand (command, data){
      switch ( command ){
        case 'office' : {
          this.officeDialogVisible = true;
          this.currentDevice = data
          break;
        }
        case 'contact' : {
          this.$refs.contactRef.open(data.id)
          break;
        }
        /*case 'location' : {
          this.$refs.amapSearchRef.open(data)
          break;
        }*/
        case 'delete' : {
          this.handleDeleteDevice(data.id)
          break;
        }
        default:
          console.warn('未知的命令:', command);
      }

    },

    validFormat(row,column){
      let value =  row[column.property]
      return value && value.length > 10 ? value.substring(0, 10) : '-';
    },

    categoryNameFormat(row,column){
      let value =  row[column.property]
      const data = this.categories.find( item => item.id === value)
      return data ? data.name : '-';
    },
    // 为表格行添加交替样式
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },

    //新增设备信息
    handleSave() {
      this.$refs.deviceForm.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，执行保存逻辑
          let list = {
            name: this.deviceForm.name,
            code: this.deviceForm.code,
            categooryId: this.deviceForm.type,
          }

          // 处理有效期范围
          if (this.validDateRange && this.validDateRange.length === 2) {
            list.validStart = formatDate(this.validDateRange[0], 'yyyy-MM-dd 00:00:00');
            list.validEnd = formatDate(this.validDateRange[1] ,'yyyy-MM-dd 23:59:59');
          }
          const res = await addDevice(list)
          if (res.code == "0000") {
            this.$message.success('设备信息保存成功');
            this.$nextTick(() => {
              this.$refs.deviceForm.resetFields();
            });
            this.dialogVisible = false;
            this.deviceList();
          }else{
            this.$message.error(res.message);
          }
        } else {
          // 表单验证失败
          this.$message.error('请完善设备信息并确保格式正确');
          return false;
        }
      });
    },

    //模板列表接口
    async templateInfo() {
      try {
        let list = {
          current: 1,
          size: 999,
        }
        const res = await templateList(list)
        this.devicesTemplate = res.result.records || []; // 确保有默认空数组
      } catch (error) {
        console.error(error)
        this.devicesTemplate = []; // 出错时重置为空数组
      }
    },


    //使用模板新增设备
    async handleSaveTemplate() {
      let list = {
        equipmentCode: this.deviceFormTemplate.equipmentCode,
        templateCode: this.deviceFormTemplate.templateCode,
        cameraCode: this.deviceFormTemplate.cameraCode
      }
      // console.log("模板传参数据",list)
      // return
      const res = await addequipmnet(list)
      if (res.code == "0000") {
        this.$message.success('设备添加成功')
        this.dialogVisibleTemplate = false
        this.deviceList()
      } else {
        this.$message.error(res.message)
      }
    },


    //删除设备
    handleDeleteDevice(id) {
      this.$confirm('确定要删除该设备吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delDevice(id)
        if (res.code == "0000") {
          this.devices = this.devices.filter(device => device.id !== id)
          this.$message.success('设备删除成功')
          this.deviceList()
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    //修改设备信息弹框
    async handleEditDevice(device) {
      this.dialogVisibleEdit = false; // 先关弹窗，避免DOM干扰
      // 关键：逐个属性赋值，不破坏响应式（因为data里已声明name/code/type）
      this.deviceFormEdit.name = device.name || '';
      this.deviceFormEdit.code = device.code || '';
      this.deviceFormEdit.type = device.categooryId || ''; // 直接赋值类型ID，无需循环
      this.deviceFormEdit.id = device.id
      // 区域级联
      this.deviceFormEdit.cityPath = device.provinceCode ? [device.provinceCode, device.cityCode, device.districtCode] : []

      if (device.validStart && device.validEnd){
        this.validDateRange = [new Date(device.validStart), new Date(device.validEnd)]
      }

      // 确保设备类型列表加载完成
      await this.categoryList();

      // 最后打开弹窗，确保数据和DOM同步
      this.dialogVisibleEdit = true;

      // 清除之前的验证状态（避免残留报错）
      // this.$nextTick(() => {
      //   this.$refs.deviceFormEdit?.clearValidate('type');
      // });
    },

    //点击保存修改设备信息
    handleEditSave() {
      this.$refs.deviceFormEdit.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，执行保存逻辑
          let list = {
            name: this.deviceFormEdit.name,
            code: this.deviceFormEdit.code,
            categooryId: this.deviceFormEdit.type,
            id: this.deviceFormEdit.id,
            provinceCode : this.deviceFormEdit.provinceCode,
            cityCode : this.deviceFormEdit.cityCode,
            districtCode : this.deviceFormEdit.districtCode,
            address : this.deviceFormEdit.address,
          }

          // 处理有效期范围
          if (this.validDateRange && this.validDateRange.length === 2) {
            list.validStart = formatDate(this.validDateRange[0], 'yyyy-MM-dd 00:00:00');
            list.validEnd = formatDate(this.validDateRange[1] ,'yyyy-MM-dd 23:59:59');
          }
          const res = await addDevice(list)
          if (res.code == "0000") {
            this.$message.success('修改设备信息成功');
            this.$nextTick(() => {
              this.$refs.deviceFormEdit.resetFields();
            });
            this.dialogVisibleEdit = false;
            this.deviceList()
          }
        } else {
          // 表单验证失败
          this.$message.error('请完善设备信息并确保格式正确');
          return false;
        }
      });
    },

    //设备列表接口
    async deviceList() {
      try {
        let list = {
          "filter": [],
          current: this.currentPage,
          size: this.pageSize,
        }
        if (this.categoryId){
          list.filter.push({
            "name": "categooryId",
            "value": this.categoryId,
            "type": "EQ"
          })
        }
        if (this.searchKeyword){
          list.filter.push({
            "name": "name",
            "value": this.searchKeyword,
            "type": "LIKE"
          })
        }
        if (this.searchKeywordCode){
          list.filter.push({
            "name": "code",
            "value": this.searchKeywordCode,
            "type": "LIKE"
          })
        }

        const res = await deviceInfo(list)
        this.devices = res.result.records || []; // 确保有默认空数组
        this.total = res.result.total;
      } catch (error) {
        console.error(error)
        this.devices = []; // 出错时重置为空数组
      }
    },

    //设备类型接口
    async categoryList() {
      try {
        const param = {
          "filter": [],
          current: 1,
          size: 1000
        }
        const res = await categoryInfo(param);
        this.deviceTypes = res.result.records;

        // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
        this.deviceTypes = this.deviceTypes.map(item => ({
          ...item,
          id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
        }));
        this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
      } catch (error) {
        console.error('获取设备类型失败：', error);
        this.$message.error('加载设备类型失败，请重试');
      }
    },

    // 搜索处理 - 重置页码并重新加载数据
    handleSearch() {
      this.currentPage = 1; // 搜索时重置到第一页
      this.deviceList()
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 当页面大小改变时，重置到第一页
      this.deviceList()
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.deviceList()
    },

    getTypeName(type) {
      const typeMap = {
        temperature: '温度传感器',
        humidity: '湿度传感器',
        switch: '智能开关',
        smoke: '烟雾报警器'
      }
      return typeMap[type] || '未知类型'
    },

    getTypeTagType(type) {
      const typeMap = {
        temperature: 'primary',
        humidity: 'success',
        switch: 'warning',
        smoke: 'info'
      }
      return typeMap[type] || 'default'
    },

    //添加设备
    handleAddDevice() {
      this.deviceForm = { name: '', code: '', type: '' }; // 重置表单
      this.dialogVisible = true;
    },

    //添加模板设备
    handleAddTemplateDevice() {
      this.deviceForm = { name: '', code: '', type: '' }; // 重置表单
      this.templateInfo()
      this.dialogVisibleTemplate = true;
    },

    handleViewDetails(item) {
      this.$router.push({
        name: 'SensorList',
        query: {
          id: item.id,
          code: item.code,
          name: item.name
        }
      })
    },
    handleOffice(e){
      const offices = this.officeList.filter(item => item.id === e)
       this.currentDevice.officeName = offices[0].name
    },
    // 获取企业
    async fetchOffices() {

      const param = {
        current : 1,
        size : 1000,
        "filter": [
          {
            "name": "enabled",
            "value": 1,
            "type": "EQ"
          }
        ],
        sorted: [
          {
            "name": "createdTime",
            "type": "DESC"
          }
        ],
      }

      try {
        const res = await officeList(param);
        if (res && res.code === "0000"){
          this.officeList = res.result.records;
        }
      } catch (error) {
        console.error('获取企业列表失败：', error);
        this.$message.error('加载企业列表失败，请重试');
      }
    },

    // 修改企业关联
    async updateOffice() {
      try {
        const res = await addDevice(this.currentDevice)
        if (res && res.code === "0000") {
          Message.success('修改设备关联成功');
          this.deviceList()
        }
      } catch (e) {
      } finally {
        this.officeDialogVisible = false;
      }
    },

  }
}
</script>

<style scoped>
/* 全局样式 */
.device-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* 页面标题 */
.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 22px;
  color: #1f2937;
  margin-bottom: 8px;
  font-weight: 600;
}

.page-header p {
  font-size: 14px;
  color: #6b7280;
}

/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.add-btn {
  transition: all 0.2s ease;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  margin: 20px;
  align-items: center;
}

.search-input {
  width: 300px;
  height: 40px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 表格样式 */
.device-table {
  margin: 0 20px;
  border-radius: 6px;
  overflow: hidden;
}

::v-deep .el-table th {
  background-color: #f7f8fa;
  font-weight: 500;
  color: #4b5563;
  padding: 12px 0;
}

::v-deep .el-table td {
  padding: 12px 0;
}

.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

::v-deep .el-table__row:hover>td {
  background-color: #f0f7ff !important;
}

::v-deep .el-table__current-row>td {
  background-color: #e6f7ff !important;
}

/* 操作按钮样式 */
.operation-btn {
  padding: 2px 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.view-btn {
  color: #1890ff;
}

.view-btn:hover {
  background-color: rgba(24, 144, 255, 0.1);
}

.edit-btn {
  color: #52c41a;
}

.edit-btn:hover {
  background-color: rgba(82, 196, 26, 0.1);
}

.delete-btn {
  color: #ff4d4f;
}

.delete-btn:hover {
  background-color: rgba(255, 77, 79, 0.1);
}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}

::v-deep .el-pagination {
  font-size: 14px;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*='suffix']) {
  height: 32px;
  line-height: 32px;
  min-width: 32px;
  border-radius: 4px;
}

::v-deep .el-pagination .el-pager li {
  margin: 0 3px;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

::v-deep .el-pagination .el-pager li.active {
  background-color: #1890ff;
  color: #fff;
}

/* 表单样式 */
.device-form {
  margin-top: 15px;
}

.form-input,
.form-select {
  width: 100%;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.form-input:focus,
.form-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 弹窗样式 */
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .custom-dialog .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
  background-color: #f7f8fa;
}

::v-deep .custom-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

::v-deep .custom-dialog .el-dialog__body {
  padding: 20px;
}

::v-deep .custom-dialog .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f2f5;
}

/* 弹窗按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-btn {
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.cancel-btn {
  background-color: #f5f5f5;
  color: #4b5563;
  border-color: #e0e0e0;
}

.cancel-btn:hover {
  background-color: #e9e9e9;
  color: #374151;
}

.confirm-btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

.confirm-btn:hover {
  background-color: #0f7ae5;
  border-color: #0f7ae5;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 优化表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .device-list-container {
    padding: 10px;
  }

  .search-input {
    width: 100%;
  }

  .header-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .pagination-container {
    text-align: center;
  }

  ::v-deep .el-table {
    font-size: 13px;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 8px 0;
  }

  .operation-btn {
    padding: 2px 6px;
    font-size: 12px;
  }
}
</style>
